import Button from '../molecules/DefaultButton';
import React, { useRef, useState } from 'react';
import OTPModal from '../molecules/OTPModal';
import { Col, Row } from 'react-bootstrap';
import ModalConfirm from '../molecules/ModalConfirm';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';

export type ReceptionActionsProps = {
  isConfirmMode: boolean;
  isNeedToVerifyOTP?: boolean;
  onClickConfirm: () => void;
  onClickSubmit: (otp?: string) => Promise<string | undefined>;
  onClickRequestOTP: () => Promise<void>;
  onClickBack: () => void;
};

const ReceptionActions = ({
  isConfirmMode,
  isNeedToVerifyOTP,
  onClickConfirm,
  onClickSubmit,
  onClickRequestOTP,
  onClickBack,
}: ReceptionActionsProps) => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [openOTPModal, setOpenOTPModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const validateReCAPTCHA = async () => {
    try {
      const token = await recaptchaRef.current?.executeAsync();
      recaptchaRef.current?.reset();
      const res = await axios.post('/api/recaptcha/verify', { token });
      const isValidReCaptcha = !!res?.data?.success;
      return isValidReCaptcha;
    } catch (error) {
      const errorData = error?.response?.data;
      alert(errorData?.message);
      return false;
    }
  };

  return (
    <Row>
      {/* left session */}
      <Col xs={4} className="d-flex justify-content-start ">
        {isConfirmMode && <Button label="戻す" strong={false} handleClick={onClickBack} />}
      </Col>
      {/* center session */}
      <Col xs={4} className="d-flex justify-content-center align-items-center">
        {isConfirmMode ? (
          <>
            <Button label="申請する" strong={false} handleClick={() => setOpenConfirmModal(true)} />

            {/* modal confirm */}
            <ModalConfirm
              show={openConfirmModal}
              title="申請確認"
              message="申請してもよろしいでしょうか？"
              onHide={() => setOpenConfirmModal(false)}
              onClickNo={() => setOpenConfirmModal(false)}
              onClickYes={async () => {
                setOpenConfirmModal(false);
                const isValidReCaptcha = await validateReCAPTCHA();
                if (isValidReCaptcha) {
                  if (isNeedToVerifyOTP) {
                    await onClickRequestOTP?.();
                    setOpenOTPModal(true);
                  } else {
                    onClickSubmit?.();
                  }
                } else {
                  onClickBack?.();
                }
              }}
            />

            {/* modal otp */}
            <OTPModal
              show={openOTPModal}
              onHide={() => {
                setOpenOTPModal(false);
              }}
              onClickVerifyOTP={onClickSubmit}
              onReRequestOTP={onClickRequestOTP}
            />
          </>
        ) : (
          <Button label="申請内容を確認する" strong={false} handleClick={onClickConfirm} />
        )}
      </Col>

      <ReCAPTCHA
        sitekey={process.env.MIX_RECAPTCHA_SITE_KEY ?? ''}
        ref={recaptchaRef}
        size="invisible"
      />
    </Row>
  );
};

export default ReceptionActions;
